import { Footer } from "../GdforEmployers/Footer";
import { Header } from "../GdforEmployers/Header";
import {Postjobbody} from "./Postjobbody";
import SignIn3mix from '../After_Sign_In/New_mix'

export function Postjob(){
    return (
        <>
        <Header/>
        <Postjobbody/>
        <SignIn3mix />
        <Footer/>
        </>
    )
}